import Component from '../abstracts/Component';

export default class SearchGuestOrderComponent extends Component {

  get SELECTORS() {
    return {
      btnSearch: '.js-search-guest-order',
      form: '.js-search-form',
      errorMsg: '.js-error-notification'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.btnSearch = document.querySelector(this.SELECTORS.btnSearch);
    this.form = document.querySelector(this.SELECTORS.form);
    this.errorMsg = document.querySelector(this.SELECTORS.errorMsg);
  }

  searchOrderSubmit() {
    const ctx = this;
    this.btnSearch.addEventListener('click', (event) => {
      event.preventDefault();
      $.ajax({
        url: '/guest/return-request?search-guest-order=true',
        data: $(ctx.form).serialize(),
        method: 'POST',
        success: function (response) {
          if(response.hasError){
            ctx.errorMsg.classList.remove('hidden');
          } else {
            ctx.errorMsg.classList.add('hidden');
            ctx.form.submit();
          }
        }
      })
    });
  }
  function() {

    $('body').off(App.MyaccountReturns.eventAddProd + ' ' + App.MyaccountReturns.eventRemoveProd).on(App.MyaccountReturns.eventAddProd + ' ' + App.MyaccountReturns.eventRemoveProd, function(e) {
      var qty = $('.return-items input:checked').length / 2; // There are 2 checkboxes for each listed product

      var btn = $('.action-box .btn');
      var singlelabel = $(btn).data('label-single');
      var multilabel = $(btn).data('label-multi');

      var label = "";

      if (qty == 0) {
        $(btn).prop('disabled', 'disabled');
        label = multilabel;
      } else if (qty == 1) {
        $(btn).prop('disabled', false);
        label = singlelabel;
      } else {
        $(btn).prop('disabled', false);
        label = multilabel;
      }

      $('.action-box .btn').html(label);
      $('.action-box span.num').text(qty);
    });

    // $('.product').each(function(i, e) {
    //
    //   var
    //     self = $(e),
    //     checkbox = self.find('.checkbox'),
    //     fieldset = self.find('fieldset');
    //
    //   checkbox.on('change', function() {
    //     if (self.is('.selected')) {
    //       self.removeClass('selected');
    //       fieldset.addClass('hidden');
    //       checkbox.find('input').prop('checked', false);
    //       $('body').trigger(App.MyaccountReturns.eventAddProd);
    //
    //     } else {
    //
    //       self.addClass('selected');
    //       fieldset.removeClass('hidden');
    //       checkbox.find('input').prop('checked', 'checked');
    //
    //       $('body').trigger(App.MyaccountReturns.eventRemoveProd);
    //     }
    //   });
    // });
  }

  render() {
    super.render();
    this.searchOrderSubmit();
  }
}
